// if (window.location.href.indexOf("/loyalty") !== -1) {
// var urlParams = new URLSearchParams(window.location.search);
    
//     if (urlParams.has('email')) {
//         var email = urlParams.get('email');      
//         $("#email").val(email);
//     } else {
//         console.log('Email parameter not found in the URL.');
//     }
// }
if (window.location.href.includes("/loyalty")) {
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get("email");

  if (email) {
    console.log("Email:", email);

    const emailInput = document.getElementById("email");
    if (emailInput) {
      emailInput.value = email;
    }
  } else {
    console.log("Email parameter not found in the URL.");
  }
}


$(document).ready(function () {
    templateCheck = $('#productPageCheck').val();
    if(templateCheck == '1') {
        $('vipps-button').remove();
    }
});